import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    meta: { layout: "empty-layout", title: "benefits" },
    component: () => import("@/views/Login/Login.vue"),
  },
  {
    path: "/login",
    name: "login",
    meta: { layout: "empty-layout", title: "benefits ავტორიზაცია" },
    component: () => import("@/views/Login/Login.vue"),
  },
  {
    path: "/passwordrecovery",
    name: "PasswordRecovery",
    meta: { layout: "empty-layout", title: "benefits პაროლის აღდგენა" },
    component: () => import("@/views/PasswordRecovery/PasswordRecovery.vue"),
  },

  /* authintificated views */
  {
    path: "/firstlogin",
    name: "FirstLogin",
    meta: { layout: "main-layout", title: "benefits პირველადი ავტორიზაცია" },
    component: () => import("@/views/Authed/FirstLogin/FirstLogin.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    meta: { layout: "main-layout", title: "benefits კონტაქტი" },
    component: () => import("@/views/Authed/Contact/Contact.vue"),
  },
  {
    path: "/clientservice",
    name: "ClientService",
    meta: { layout: "main-layout", title: "benefits კლიენტის მომსახურება" },
    component: () => import("@/views/Authed/ClientService/ClientService.vue"),
  },
  {
    path: "/report",
    name: "Report",
    meta: { layout: "main-layout", title: "benefits რეპორტი" },
    component: () => import("@/views/Authed/Report/Report.vue"),
  },
  {
    path: "/reportadmin",
    name: "ReportAdmin",
    meta: { layout: "main-layout", title: "benefits რეპორტი" },
    component: () => import("@/views/Authed/ReportAdmin/ReportAdmin.vue"),
  },
  {
    path: "/reportcarwash",
    name: "ReportCarWash",
    meta: { layout: "main-layout", title: "benefits რეპორტი" },
    component: () => import("@/views/Authed/ReportCarWash/ReportCarWash.vue"),
  },
  {
    path: "/carwashadmin",
    name: "CarWashMenejerList",
    meta: { layout: "main-layout", title: "benefits კომპანიები" },
    component: () =>
      import(
        "@/views/Authed/CarWashAdministration/CarWashMenejerList/CarWashMenejerList.vue"
      ),
  },
  {
    path: "/carwashdetail/:carwashid",
    name: "CarWashDetail",
    meta: { layout: "main-layout", title: "benefits კომპანიის დეტალები" },
    component: () =>
      import(
        "@/views/Authed/CarWashAdministration/EditCarWash/EditCarWash.vue"
      ),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if (previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }
  Array.from(
    document.querySelectorAll("[data-vue-router-controlled]")
  ).map((el) => el.parentNode.removeChild(el));
  if (!nearestWithMeta) return next();
  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement("meta");
      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });
      tag.setAttribute("data-vue-router-controlled", "");
      return tag;
    })
    .forEach((tag) => document.head.appendChild(tag));

  next();
});

export default router;
